const search = {
  state: {
    searchType: ''
  },

  mutations: {
    SET_SEARCHTYPE: (state, item) => {
      state.searchType = item;
    }
  },

  actions: {}
};

export default search;
